import React from "react";
import BasicPage from "../../../common/basicPage/BasicPage";
import {CelebrateIcon} from "./CelebrateIcon";
import onboarding from "../../../../services/onboarding/onboarding";
import {inAppAnalyticsService} from "../../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/setup-feedback-you-are-all-set';

interface IYouAreAllSetProps {
  
}

export default function YouAreAllSet({}: IYouAreAllSetProps) {
  const headerTextContent: string = "You're all set!"

  return (
    <BasicPage
      useMosaicBackground={true}
      headerIconComponent={<CelebrateIcon/>}
      portraitModeHeaderText={headerTextContent}
      backButtonAnalyticsIdentifier={'you-are-all-set-back'}
      screenClass={screenClass}
      content={
        <>
          <h1>{headerTextContent}</h1>
          <p>You&apos;re ready to start learning with Playground Sessions.</p>
          <p>Next up is <strong>Bootcamp</strong>, our step-by-step learning path designed to help you build a strong foundation, whether you&apos;re brand new or brushing up on your skills.
          </p>
        </>
      }
      actionButton={{
        text: "Start playing",
        onClick: () => {
          inAppAnalyticsService.onButton_press('you-are-all-set-start-playing', {screenClass});
          onboarding.completeOnboarding();
        },
        buttonType: "secondary",
      }}
    />
  );
}
